// Supabase Configuration
// Replace these values with your actual Supabase project credentials

export const SUPABASE_CONFIG = {
  // Get these from your Supabase Dashboard > Settings > API
  url: 'https://lpmbrpuffqicnfamemqk.supabase.co',
  anonKey: 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImxwbWJycHVmZnFpY25mYW1lbXFrIiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDIzNzUxMTMsImV4cCI6MjA1Nzk1MTExM30.-cxnF3NhHR6Bcx9Lur033P1CT8WhZi0BpqnxAtY9VBw',
};

// Instructions:
// 1. Go to https://supabase.com/dashboard
// 2. Select your project
// 3. Go to Settings > API
// 4. Copy the "Project URL" and replace YOUR_SUPABASE_URL_HERE
// 5. Copy the "anon public" key and replace YOUR_SUPABASE_ANON_KEY_HERE